import ColorPickerPopover from "components/common/ColorPickerPopover";
import CustomError from "components/common/CustomError";
import CustomField from "components/common/CustomField";
import CustomLabel from "components/common/CustomLabel";
import DetailsPageTitle from "components/common/DetailsPageTitle";
import FileUpload from "components/common/FileUpload";
import FormButtons from "components/common/FormButtons";
import IsLoading from "components/common/IsLoading";
import { updateOrganizationSettingsSchema } from "components/common/Validation";
import { Form, Formik } from "formik";
import { InputSwitch } from "primereact/inputswitch";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  getOrganizationSettingsDetails,
  updateOrganizationSettings,
} from "store/actions/organizationSlice";
import { showAlert } from "store/reducers/alertReducer";

const initialValues = {
  cancelInfo: {
    checkBeforeCancel: false,
    valueInHours: null,
  },
  maintenanceMode: {
    iOSApp: null,
    androidApp: null,
    website: null,
  },
  forceAppUpdate: {
    iOSApp: null,
    androidApp: null,
  },
  vatInfo: {
    title: "",
    titleAr: "",
    value: null,
    registeredNo: "",
  },
  brandInfo: {
    theme: {
      primaryColor: "#000000",
      secondaryColor: "#FFFFFF",
    },
    faviconIconUrl: [],
    logo: [],
    loginPageBGImage: [],
  },
};

const defaultPickerColor = "#000000";
const presetColors = [
  "#51bbf0",
  "#1294d5",
  "#ffffff",
  "#bbbbbb",
  "#a4a4a4",
  "#64748b",
  "#30322c",
  "#020816",
  "#d6e47f",
  "#0C3553",
  "#D5B086",
  "#FF5733",
  "#33FF57",
  "#2e65f3",
];

const UpdateOrganizationSettings = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [formValues, setFormValues] = useState(initialValues);

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const { gettingDetails2, isLoading, organizationSettingsDetails } =
    useSelector((state) => state.Organizations);

  useEffect(() => {
    if (organizationSettingsDetails && !gettingDetails2) {
      const {
        cancelInfo,
        forceAppUpdate,
        maintenanceMode,
        vatInfo,
        brandInfo,
      } = organizationSettingsDetails || {};

      setFormValues({
        cancelInfo,
        maintenanceMode: {
          iOSApp: maintenanceMode?.iOSApp ?? false,
          androidApp: maintenanceMode?.androidApp ?? false,
          website: maintenanceMode?.website ?? false,
        },
        forceAppUpdate: {
          iOSApp: forceAppUpdate?.iOSApp ?? false,
          androidApp: forceAppUpdate?.androidApp ?? false,
        },
        vatInfo: {
          title: vatInfo?.title || "",
          titleAr: vatInfo?.titleAr || "",
          value: vatInfo?.value ?? null,
          registeredNo: vatInfo?.registeredNo || "",
        },
        brandInfo: {
          theme: {
            primaryColor: brandInfo?.theme?.primaryColor || "#000000",
            secondaryColor: brandInfo?.theme?.secondaryColor || "#FFFFFF",
          },
          logo: brandInfo?.logo ? [brandInfo?.logo] : [],
          loginPageBGImage: brandInfo?.loginPageBGImage
            ? [brandInfo?.loginPageBGImage]
            : [],
          faviconIconUrl: brandInfo?.faviconIconUrl
            ? [brandInfo?.faviconIconUrl]
            : [],
        },
      });
    }
  }, [organizationSettingsDetails, gettingDetails2]);

  useEffect(() => {
    const getDetails = () => {
      const payload = {
        id,
      };
      dispatch(getOrganizationSettingsDetails(payload));
    };
    getDetails();
  }, []);

  const handleOnSubmit = (values) => {
    const { cancelInfo, forceAppUpdate, maintenanceMode, vatInfo, brandInfo } =
      values || {};

    let data = new FormData();
    data.append("id", id);
    // data.append("vatInfo[title]", vatInfo?.title || "");
    // data.append("vatInfo[titleAr]", vatInfo?.titleAr || "");
    // data.append("vatInfo[value]", vatInfo?.value || "");
    // data.append("vatInfo[registeredNo]", vatInfo?.registeredNo || "");
    // data.append("maintenanceMode[iOSApp]", maintenanceMode?.iOSApp);
    // data.append("maintenanceMode[androidApp]", maintenanceMode?.androidApp);
    // data.append("maintenanceMode[website]", maintenanceMode?.website);
    // data.append("forceAppUpdate[iOSApp]", forceAppUpdate?.iOSApp);
    // data.append("forceAppUpdate[androidApp]", forceAppUpdate?.androidApp);
    // data.append("cancelInfo[checkBeforeCancel]", cancelInfo?.checkBeforeCancel);
    // data.append("cancelInfo[valueInHours]", cancelInfo?.valueInHours);
    // data.append("referralInfo[earnedLeafForReceiver]", "10");
    // data.append("referralInfo[earnedLeafForSender]", "20");
    // data.append("referralInfo[expiredIn]", "6");
    data.append(
      "brandInfo[theme][primaryColor]",
      brandInfo?.theme?.primaryColor
    );
    data.append(
      "brandInfo[theme][secondaryColor]",
      brandInfo?.theme?.secondaryColor
    );
    console.log(brandInfo?.logo?.[0])
    if (brandInfo?.logo?.[0]) {
      data.append("brandInfo[logo]", brandInfo.logo[0]);
    }

    if (brandInfo?.loginPageBGImage?.[0]) {
      data.append("brandInfo[loginPageBGImage]", brandInfo.loginPageBGImage[0]);
    }

    if (brandInfo?.faviconIconUrl?.[0]) {
      data.append("brandInfo[faviconIconUrl]", brandInfo.faviconIconUrl[0]);
    }
    dispatch(updateOrganizationSettings(data))
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  return (
    <div>
      {gettingDetails2 ? (
        <IsLoading />
      ) : (
        <Formik
          initialValues={formValues}
          validationSchema={updateOrganizationSettingsSchema}
          enableReinitialize
          onSubmit={handleOnSubmit}
        >
          {({ errors, values, touched, setFieldValue }) => (
            <Form>
              {/* <h2 className="fs_20 mt-3">
                {t("Booking Cancellation Settings")}
              </h2>
              <div className="common_wrapper">
                <Row>
                  <Col lg={6}>
                    <div className="form_field mb-0 d-flex align-items-center gap-3">
                      <InputSwitch
                        checked={values?.cancelInfo?.checkBeforeCancel}
                        onChange={(e) => {
                          const newValue =
                            !values?.cancelInfo?.checkBeforeCancel;
                          setFieldValue(
                            "cancelInfo.checkBeforeCancel",
                            newValue
                          );
                          if (!newValue) {
                            setFieldValue("cancelInfo.valueInHours", 0);
                          }
                        }}
                      />
                      <label
                        htmlFor="cancelInfo.checkBeforeCancel"
                        className="mb-0"
                      >
                        {t(
                          "Do you want to customized booking cancellation setting"
                        )}
                      </label>
                    </div>
                  </Col>
                  {values?.cancelInfo?.checkBeforeCancel && (
                    <Col lg={6}>
                      <div className="form_field">
                        <CustomLabel
                          htmlFor="cancelInfo.valueInHours"
                          label={t(
                            "Can cancel and get refund before booking start in : -- hours"
                          )}
                        />
                        <CustomField
                          name="cancelInfo.valueInHours"
                          type="number"
                          placeholder={t("In Hours")}
                          touched={touched}
                          errors={errors}
                        />
                      </div>
                    </Col>
                  )}
                </Row>
              </div> */}

              {/* <h2 className="fs_20 mt-3">{t("Maintenance Mode Settings")}</h2>
              <div className="common_wrapper">
                <Row>
                  <Col lg={4}>
                    <div className="form_field mb-0 d-flex align-items-center gap-3">
                      <InputSwitch
                        checked={values?.maintenanceMode?.iOSApp}
                        onChange={(e) => {
                          setFieldValue(
                            "maintenanceMode.iOSApp",
                            !values?.maintenanceMode?.iOSApp
                          );
                        }}
                      />
                      <label htmlFor="maintenanceMode.iOSApp" className="mb-0">
                        {t("iOS App")}
                      </label>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form_field mb-0 d-flex align-items-center gap-3">
                      <InputSwitch
                        checked={values?.maintenanceMode?.androidApp}
                        onChange={(e) => {
                          setFieldValue(
                            "maintenanceMode.androidApp",
                            !values?.maintenanceMode?.androidApp
                          );
                        }}
                      />
                      <label
                        htmlFor="maintenanceMode.androidApp"
                        className="mb-0"
                      >
                        {t("Android App")}
                      </label>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form_field mb-0 d-flex align-items-center gap-3">
                      <InputSwitch
                        checked={values?.maintenanceMode?.website}
                        onChange={(e) => {
                          setFieldValue(
                            "maintenanceMode.website",
                            !values?.maintenanceMode?.website
                          );
                        }}
                      />
                      <label htmlFor="maintenanceMode.website" className="mb-0">
                        {t("Website")}
                      </label>
                    </div>
                  </Col>
                </Row>
              </div> */}

              {/* <h2 className="fs_20 mt-3">{t("Force Update Settings")}</h2>
              <div className="common_wrapper">
                <Row>
                  <Col lg={4}>
                    <div className="form_field mb-0 d-flex align-items-center gap-3">
                      <InputSwitch
                        checked={values?.forceAppUpdate?.iOSApp}
                        onChange={(e) => {
                          setFieldValue(
                            "forceAppUpdate.iOSApp",
                            !values?.forceAppUpdate?.iOSApp
                          );
                        }}
                      />
                      <label htmlFor="forceAppUpdate.iOSApp" className="mb-0">
                        {t("iOS App")}
                      </label>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form_field mb-0 d-flex align-items-center gap-3">
                      <InputSwitch
                        checked={values?.forceAppUpdate?.androidApp}
                        onChange={(e) => {
                          setFieldValue(
                            "forceAppUpdate.androidApp",
                            !values?.forceAppUpdate?.androidApp
                          );
                        }}
                      />
                      <label
                        htmlFor="forceAppUpdate.androidApp"
                        className="mb-0"
                      >
                        {t("Android App")}
                      </label>
                    </div>
                  </Col>
                </Row>
              </div> */}

              {/* <h2 className="fs_20 mt-3">{t("VAT Settings")}</h2>
              <div className="common_wrapper">
                <Row>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="vatInfo.title"
                        label={t("English Title")}
                      />
                      <CustomField
                        name="vatInfo.title"
                        type="text"
                        placeholder={t("Enter English Title")}
                        touched={touched.vatInfo}
                        errors={errors.vatInfo}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="vatInfo.titleAr"
                        label={t("Arabic Title")}
                      />
                      <CustomField
                        name="vatInfo.titleAr"
                        type="text"
                        placeholder={t("Enter Arabic Title")}
                        touched={touched.offerDetails}
                        errors={errors.offerDetails}
                        isArabic={true}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="vatInfo.value"
                        label={t("Value in %")}
                      />
                      <CustomField
                        name="vatInfo.value"
                        type="number"
                        placeholder={t("Enter Value")}
                        touched={touched.offerDetails}
                        errors={errors.offerDetails}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="vatInfo.registeredNo"
                        label={t("Registered No")}
                      />
                      <CustomField
                        name="vatInfo.registeredNo"
                        type="string"
                        placeholder={t("Enter Registered No")}
                        touched={touched.offerDetails}
                        errors={errors.offerDetails}
                      />
                    </div>
                  </Col>
                </Row>
              </div> */}

              <h2 className="fs_20 mt-3">{t("Brand Information")}</h2>
              <div className="common_wrapper">
                <Row>
                  <Col lg={6}>
                    <div className="form_field">
                      <ColorPickerPopover
                        label={t("Primary Color")}
                        value={values.brandInfo.theme.primaryColor}
                        onChange={(val) =>
                          setFieldValue("brandInfo.theme.primaryColor", val)
                        }
                        defaultColor={defaultPickerColor}
                        presetColors={presetColors}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <ColorPickerPopover
                        label={t("Secondary Color")}
                        value={values.brandInfo.theme.secondaryColor}
                        onChange={(val) =>
                          setFieldValue("brandInfo.theme.secondaryColor", val)
                        }
                        defaultColor={defaultPickerColor}
                        presetColors={presetColors}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="brandInfo.theme.faviconIconUrl"
                        label={t("Favicon Icon")}
                      />
                      <FileUpload
                        uploadedFiles={values?.brandInfo?.faviconIconUrl || []}
                        setUploadedFiles={(files) =>
                          setFieldValue("brandInfo.faviconIconUrl", files)
                        }
                        maxFiles={1}
                        maxFileSize={0.6 * 1024 * 1024}
                        acceptedFileTypes={["image/png", "image/x-icon"]}
                        requireSquare={true}
                        requireRectangle={false}
                        className={
                          touched?.brandInfo?.faviconIconUrl &&
                          errors?.brandInfo?.faviconIconUrl
                            ? "invalid"
                            : ""
                        }
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="brandInfo.theme.logo"
                        label={t("Logo")}
                      />
                      <FileUpload
                        uploadedFiles={values?.brandInfo?.logo || []}
                        setUploadedFiles={(files) =>
                          setFieldValue("brandInfo.logo", files)
                        }
                        maxFiles={1}
                        maxFileSize={0.6 * 1024 * 1024}
                        acceptedFileTypes={[
                          "image/png",
                          "image/jpeg",
                          "image/svg+xml",
                        ]}
                        requireSquare={false}
                        requireRectangle={false}
                        className={
                          touched?.brandInfo?.logo && errors?.brandInfo?.logo
                            ? "invalid"
                            : ""
                        }
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="brandInfo.theme.loginPageBGImage"
                        label={t("Login Page Background Image")}
                      />
                      <FileUpload
                        uploadedFiles={
                          values?.brandInfo?.loginPageBGImage || []
                        }
                        setUploadedFiles={(files) =>
                          setFieldValue("brandInfo.loginPageBGImage", files)
                        }
                        maxFiles={1}
                        maxFileSize={0.6 * 1024 * 1024}
                        acceptedFileTypes={[
                          "image/png",
                          "image/jpeg",
                          "image/svg+xml",
                        ]}
                        requireSquare={false}
                        requireRectangle={true}
                        className={
                          touched?.brandInfo?.loginPageBGImage &&
                          errors?.brandInfo?.loginPageBGImage
                            ? "invalid"
                            : ""
                        }
                      />
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="mt-5">
                      <FormButtons
                        isLoading={isLoading}
                        addBtnText={t("Update")}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default UpdateOrganizationSettings;
